/**
 * A validation outcome carrying either a cleaned value or a sentence fit to
 * show a person.
 *
 * Validation never throws. A thrown error would have to be caught somewhere
 * that does not know what the user was trying to do, and would arrive at the
 * browser as "something went wrong"; a returned message arrives next to the
 * field that caused it.
 */
export type Result<T> =
  { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: string };

export function ok<T>(value: T): Result<T> {
  return { ok: true, value };
}

export function err<T = never>(error: string): Result<T> {
  return { ok: false, error };
}
